import React from 'react';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div style={{ padding: '20px' }}>
    
      <ContactForm />
    </div>
  );
};

export default Contact;
